import { useSelector } from "react-redux";
import loaderIcon from '../../../images/loader.svg'
import style from './confirm-popup.module.scss'
import { getPoints } from "../../../utils/getPoints";

export const ConfirmPopup = ({ close, confirm, price, title }) => {
    const lang = useSelector(state => state.app.currentLang);
    const langName = useSelector(state => state.app.currentLangName)
    const loading = useSelector(state => state.app.confirmPopupLoading)
    const remainPoints = useSelector(state => state.game.remainPoints);

    return (
        <div className="codePopup">
            <div className="codePopup__back" onClick={() => close()}></div>
            <div className="codePopup__wrap">
                <div className="codePopup__box">
                    <div className={style["confirm-popup__head"]}>
                        {title}
                        <div className="codePopup__close" onClick={() => close()}>
                        </div>
                    </div>
                    <div className={style["confirm-popup__body"]}>
                        {
                            remainPoints
                                ? <>
                                    <p>
                                        {lang.confirm.notEnough1 + ' ' }
                                        <span>{ remainPoints + ' ' + getPoints(langName, remainPoints)}</span> 
                                            { ' ' + lang.confirm.notEnough2}
                                    </p>
                                    <button className={style["confirm-popup__ok"]} onClick={() => close()}>
                                        {lang.confirm.button3}
                                    </button>
                                </>
                                : <div className={style["confirm-popup__buttons"]}>
                                    <button className={style["confirm-popup__cansel"]} onClick={() => close()}>
                                        {lang.confirm.button2}
                                    </button>
                                    <button className={style["confirm-popup__confirm"]} onClick={() => confirm()}>
                                        {
                                            loading
                                                ? <>{lang.confirm.button4}<img src={loaderIcon} alt="loader" /></>
                                                : <>{lang.confirm.button1 + ' (-' + price}<span className={style['confirm-popup__confirm_coin']}></span>{')'}</>
                                        }
                                    </button>
                                </div>

                        }

                    </div>
                </div>
            </div>
        </div>
    )
}